import { render, staticRenderFns } from "./sensorinfo.vue?vue&type=template&id=008ec6db"
import script from "./sensorinfo.vue?vue&type=script&lang=js"
export * from "./sensorinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports